/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_Nav_DownloadInputs */

const en_gc_home_nav_download = /** @type {(inputs: Gc_Home_Nav_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download`)
};

const zh_gc_home_nav_download = /** @type {(inputs: Gc_Home_Nav_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载`)
};

/**
* | output |
* | --- |
* | "Download" |
*
* @param {Gc_Home_Nav_DownloadInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_nav_download = /** @type {((inputs?: Gc_Home_Nav_DownloadInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_Nav_DownloadInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_nav_download(inputs)
	return zh_gc_home_nav_download(inputs)
});
export { gc_home_nav_download as "gc.home.nav.download" }